const tokenPattern = /^[a-zA-Z0-9][a-zA-Z0-9._~-]{0,199}$/;
const idPattern = /^\d{1,20}$/;

const parameterValidators = new Map([
  ['page', value => /^(?:[1-9]\d{0,3}|10000)$/.test(value)],
  ['utm_source', value => tokenPattern.test(value)],
  ['utm_medium', value => tokenPattern.test(value)],
  ['utm_campaign', value => tokenPattern.test(value)],
  ['utm_id', value => tokenPattern.test(value)],
  ['utm_content', value => tokenPattern.test(value)],
  ['aw_campaign_id', value => idPattern.test(value)],
  ['aw_adgroup_id', value => idPattern.test(value)],
  ['aw_creative', value => idPattern.test(value)],
  ['aw_network', value => /^(?:d|g|s)$/.test(value)],
  ['aw_device', value => /^(?:c|m|t)$/.test(value)],
  ['aw_matchtype', value => /^(?:b|e|p)$/.test(value)],
]);

function pathOnly(value) {
  try {
    const url = new URL(value, 'https://analytics.invalid');
    return /^(?:http:|https:)$/.test(url.protocol) ? url.pathname : '/';
  } catch {
    return '/';
  }
}

function sanitizeUmamiUrl(value, fallbackPath = '/') {
  if (typeof value !== 'string') return pathOnly(fallbackPath);

  let url;

  try {
    url = new URL(value, 'https://analytics.invalid');
  } catch {
    return pathOnly(fallbackPath);
  }

  if (!/^(?:http:|https:)$/.test(url.protocol)) return pathOnly(fallbackPath);

  const query = new URLSearchParams();

  url.searchParams.forEach((value, name) => {
    const isValid = parameterValidators.get(name);
    if (isValid?.(value)) query.append(name, value);
  });

  const search = query.toString();
  return `${url.pathname}${search ? `?${search}` : ''}`;
}

function sanitizeUmamiReferrer(value, currentOrigin) {
  if (typeof value !== 'string' || value === '') return '';

  try {
    const origin = new URL(currentOrigin);
    const url = new URL(value, origin);

    if (!/^(?:http:|https:)$/.test(url.protocol)) return '';

    const path =
      url.origin === origin.origin ? sanitizeUmamiUrl(url.href) : url.pathname;
    return `${url.origin}${path}`;
  } catch {
    return '';
  }
}

function sanitizeUmamiPayload(_type, payload) {
  if (!payload || typeof payload !== 'object') return false;

  const fallbackPath =
    typeof window === 'undefined' ? '/' : window.location.pathname;
  const currentOrigin =
    typeof window === 'undefined'
      ? 'https://analytics.invalid'
      : window.location.origin;
  const sanitized = { ...payload };
  let changed = false;

  if (typeof payload.url === 'string') {
    sanitized.url = sanitizeUmamiUrl(payload.url, fallbackPath);
    changed = true;
  }
  if (typeof payload.referrer === 'string') {
    sanitized.referrer = sanitizeUmamiReferrer(payload.referrer, currentOrigin);
    changed = true;
  }

  return changed ? sanitized : payload;
}

module.exports = {
  sanitizeUmamiPayload,
  sanitizeUmamiReferrer,
  sanitizeUmamiUrl,
};
